"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    /**
     * Represents a video asset type.
     */
    AssetType[AssetType["VIDEO"] = 0] = "VIDEO";
    /**
     * Represents an image asset type.
     */
    AssetType[AssetType["IMAGE"] = 1] = "IMAGE";
    /**
     * Represents a document asset type.
     */
    AssetType[AssetType["DOCUMENT"] = 2] = "DOCUMENT";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
//# sourceMappingURL=assetType.enum.js.map